import { AppEventSdk } from '@sxm-de/dev-kits/web-sdk/types';

type ClickTrackPayload = {
    linkKey?: string;
    name?: string;
    event?: UIEvent;
};

export function initClickTrackFunctions(appEventSdk: AppEventSdk) {
    const clickTrack = ({
        linkReference,
        linkType,
        linkKey,
    }: {
        linkReference: string | UIEvent;
        linkType:
            | 'routing'
            | 'submit'
            | 'modal'
            | 'ui'
            | 'exit'
            | 'player'
            | 'download'
            | 'chat'
            | 'refresh'
            | 'login';
        linkKey?: string;
    }) => {
        const linkName =
            linkReference instanceof UIEvent
                ? (linkReference.target as HTMLElement)['innerText']
                : linkReference;
        appEventSdk.trackEvent({
            event: 'user-click',
            linkName,
            linkType,
            ...(linkKey ? { linkKey } : {}),
        });
    };

    return {
        clickTrackSubmit: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'submit',
                linkKey,
            });
        },
        clickTrackExit: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'exit',
                linkKey,
            });
        },
        clickTrackModal: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'modal',
                linkKey,
            });
        },
        clickTrackRouting: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'routing',
                linkKey,
            });
        },
        clickTrackUi: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'ui',
                linkKey,
            });
        },
        clickTrackPlayer: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'player',
                linkKey,
            });
        },
        clickTrackDownload: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'download',
                linkKey,
            });
        },
        clickTrackChat: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'chat',
                linkKey,
            });
        },
        clickTrackRefresh: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'refresh',
                linkKey,
            });
        },
        clickTrackLogin: ({ linkKey, name, event }: ClickTrackPayload) => {
            clickTrack({
                linkReference: event || name || '',
                linkType: 'login',
                linkKey,
            });
        },
    };
}
